<script lang="ts" setup>
import { ElTag } from 'element-plus'

const props = withDefaults(
  defineProps<{
    type?: 'success' | 'warning' | 'danger' | 'info' | 'light-purple'
    size?: 'small' | 'default' | 'large'
    effect?: 'dark' | 'light' | 'plain'
    round?: boolean
  }>(),
  {
    type: 'success',
    size: 'small',
    effect: 'light',
    round: false,
  }
)
</script>

<template>
  <ElTag
    :type="props.type === 'light-purple' ? 'info' : props.type"
    :class="{ 'light-purple-tag': props.type === 'light-purple' }"
    :size="props.size"
    :effect="effect"
    disable-transitions
    :round="props.round"
  >
    <slot />
  </ElTag>
</template>

<style scoped>
.light-purple-tag {
  background-color: #f5edfa !important;
  border-color: #9971c32f !important;
  color: #4f1e82 !important;
}
</style>
